import { LogLevel } from "@/types/enums";

export interface LogLevelDisplay {
  label: string;
  className: string;
}

/**
 * `LogLevel` label + colour map (sc-114197). Keyed by the enum, so a new member is a compile error until
 * it is given a label here. The label is always rendered beside the colour, so colour is never the sole
 * cue — and the int id is a wire value, never display text.
 */
export const LOG_LEVEL_DISPLAY: Record<LogLevel, LogLevelDisplay> = {
  [LogLevel.Trace]: { label: "Trace", className: "text-muted-foreground" },
  [LogLevel.Debug]: { label: "Debug", className: "text-muted-foreground" },
  [LogLevel.Information]: { label: "Information", className: "text-foreground" },
  [LogLevel.Warning]: { label: "Warning", className: "text-amber-700 dark:text-amber-400" },
  [LogLevel.Error]: { label: "Error", className: "text-destructive" },
  [LogLevel.Critical]: { label: "Critical", className: "text-destructive" },
  [LogLevel.None]: { label: "None", className: "text-muted-foreground" },
};

const UNKNOWN_LEVEL: LogLevelDisplay = { label: "Unknown", className: "text-muted-foreground" };

/** The display for a wire level id; an id outside the enum renders "Unknown", never the digit. */
export function logLevelDisplay(id: number): LogLevelDisplay {
  return Object.prototype.hasOwnProperty.call(LOG_LEVEL_DISPLAY, id)
    ? LOG_LEVEL_DISPLAY[id as LogLevel]
    : UNKNOWN_LEVEL;
}
